import { useTranslation, lang } from '@/helpers/translate';
import ByTags from '@/components/space/bytags.js';

export default function RootComponent({ similarSpacesDefault }) {
  const { t } = useTranslation();

  function getSimilarSpace() {
    return similarSpacesDefault;
  }
  return (
    <>
      {similarSpacesDefault?.length > 0
        ? (
          <section className="bg-purple-0 pt-1 text-purple-5/50 flex-row">
            <div className="container mt-8 md:mt-10 mx-auto px-6 md:px-10 lg:px-10 xl:px-20 2xl:px-48 flex flex-col">
              <h2 className="font-medium text-black text-xl lg:text-2xl pb-4">{t('space:space_similar')}</h2>
              <ByTags spaces={getSimilarSpace()} />
            </div>
          </section>
        )
        : ' '}
    </>
  );
}
